import React from 'react';

const Switch = ({
  controlId,
  isOn,
  handleToggle,
  disabled,
}) => {
  const checked = Boolean(isOn);

  return (
    <div className={`switch ${disabled ? 'disabled' : ''}`}>
      <input
        checked={checked}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={controlId}
        type="checkbox"
        disabled={disabled}
      />
      <label
        style={{ background: checked ? 'var(--primary, #5b49fe)' : undefined }}
        className="react-switch-label"
        htmlFor={controlId}
      >
        <span className={`react-switch-button`} />
      </label>
    </div>
  );
};

export default Switch;